<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 14 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.58 20L2.24 14.39H0.0200001V11.57H2.57L2.99 8.27H0.62V5.45H3.35L3.98 0.499999H6.5L5.9 5.45H9.02L9.65 0.499999H12.17L11.57 5.45H13.94V8.27H11.21L10.82 11.57H13.34V14.39H10.49L9.8 20H7.25L7.91 14.39H4.82L4.13 20H1.58ZM5.15 11.57H8.24L8.66 8.27H5.54L5.15 11.57Z"
      fill="#495057"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconHashtag',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style scoped>
</style>